import { put, takeEvery } from "redux-saga/effects";
import { Auth } from "../../services";
import type { SignupAction, ConfirmSignupAction } from "../types";

function* doSignup(action: SignupAction) {
  try {
    const result = yield Auth.signUp({
      username: action.email,
      password: action.password,
    });

    if (result != null && !result.userConfirmed) {
      yield put({
        type: "SIGNUP_NEEDS_CONFIRMATION",
      });
    } else {
      console.error(result);
      throw new Error();
    } // not certain what to do here about other cases yet (hi future growth team!!!)
  } catch (e) {
    console.error(e);
    yield put({
      type: "SIGNUP_FAIL",
      errorMessage: e.message,
    });
  }
}

function* doConfirmSignup(action: ConfirmSignupAction) {
  // this has a bunch of issues + holes, but we will "do things that don't scale" and attempt to help people directly
  try {
    yield Auth.confirmSignUp(action.email, action.confirmCode);
    yield put({
      type: "CONFIRM_SIGNUP_SUCCESS",
    });
  } catch (e) {
    yield put({
      type: "CONFIRM_SIGNUP_FAIL",
    });
    alert(e.message);
    return;
  }

  if (action.password != null) {
    try {
      yield Auth.signIn(action.email, action.password);
      yield put({
        type: "LOGIN_SUCCESS",
      });
    } catch (e) {
      yield put({
        type: "LOGIN_FAIL",
      });
      alert(e.message);
    }
  }
}

function* signupSaga() {
  yield takeEvery("SIGNUP", doSignup);
  yield takeEvery("CONFIRM_SIGNUP", doConfirmSignup);
}

export default signupSaga;
